import { authCodeType, loginAPI, loginGoogleAPI, loginUserType } from "api/apiHelper";
import { AppDispatch } from "app/store";
import { loginFailure, loginSuccess, setAuthLoading } from "./reducer";
import { setLocalStoragePermissions, setLocalStorageTokens, setLocalStorageIsManager, setLocalStorageIsClientUser } from "utils/utilityFunctions";
import axios from "axios";


export enum LoginType {
  Default = "default",
  Google = "google",
}

const getFriendlyLoginError = (error: any, loginType: LoginType): string => {
  if (!axios.isAxiosError(error)) {
    return "Login failed. Please try again.";
  }

  const status = error.response?.status;
  const responseData: any = error.response?.data || {};
  const detail = responseData?.detail;
  const nonFieldError = Array.isArray(responseData?.non_field_errors)
    ? responseData.non_field_errors[0]
    : undefined;
  const firstFieldError =
    responseData?.password?.[0] ||
    responseData?.username?.[0] ||
    responseData?.authorization_code?.[0];

  if (loginType === LoginType.Google) {
    if (status === 403 || (typeof detail === "string" && /not authorized|allowed to log in/i.test(detail))) {
      return "You are not authorized to log in.";
    }

    if (typeof detail === "string" && detail.trim()) {
      return detail;
    }

    return "Google login failed. Please try again.";
  }

  const authText = `${detail || ""} ${nonFieldError || ""}`.toLowerCase();
  if (authText.includes("unable to log in with provided credentials") || status === 401) {
    return "Incorrect password. Please try again.";
  }

  return detail || nonFieldError || firstFieldError || "Login failed. Please try again.";
};

export const loginUser = (
    data:loginUserType | authCodeType, 
    onLoginSuccess: ()=>void, 
    loginType:LoginType=LoginType.Default 
  ) => async (dispatch : AppDispatch) => {
    try {

      dispatch(setAuthLoading(true));

      let response;

      if(loginType === LoginType.Google){
        response =  await loginGoogleAPI(data as authCodeType);
      }
      else {
        response =  await loginAPI(data as loginUserType);
      }
      dispatch(loginSuccess(response.data))
      setLocalStorageTokens(response.data.token);
      setLocalStoragePermissions(response.data.permissions);
      setLocalStorageIsManager(response.data.is_manager);
      setLocalStorageIsClientUser(response.data.is_clientuser);
      dispatch(setAuthLoading(false));
      onLoginSuccess()
    } catch (error: any) {
      dispatch(loginFailure(getFriendlyLoginError(error, loginType)));
      dispatch(setAuthLoading(false));
    }
  };

